import { createFileRoute, notFound } from '@tanstack/react-router';
import UploadAnalytes from '../../../pages/uploadAnalytes/UploadAnalytes';
import { CREATE_ANALYTE } from '../../../utils/permissions';

export const Route = createFileRoute('/_authenticated/_navbar/upload-analytes')(
  {
    beforeLoad: ({ context }) => {
      if (!context.auth.hasPermission(CREATE_ANALYTE)) {
        throw notFound();
      }
    },
    component: UploadAnalytes,
  }
);
